import { createFileRoute, useNavigate } from '@tanstack/react-router'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { last } from 'remeda'
import { AppLoader } from '~/components/loader'
import { getAuthToken, unpackAuthToken } from '~/helpers/sessionHelpers'

export const Route = createFileRoute('/_authenticated/o/r/g/$')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { _splat } = Route.useParams()
  console.log('hell yeah')
  useEffect(() => {
    const lastOrgAlias = Cookies.get('last-org-alias')
    if (lastOrgAlias) {
      console.log('Redirecting using last org alias')
      navigate({
        to: `/${lastOrgAlias}/${_splat || ''}`,
        search: (prevSearch) => prevSearch,
        replace: true,
      })
    } else {
      const token = unpackAuthToken(getAuthToken())
      if (token) {
        console.log('Redirecting using auth token')
        if (token.oui) {
          navigate({
            to: `/org/${last(Object.keys(token.oui))}/${_splat || ''}`,
            search: (prevSearch) => prevSearch,
            replace: true,
          })
        }
      }
    }
  }, [_splat, navigate])

  return <AppLoader />
}
